export interface FilterMapping {
  minKey: string;
  maxKey: string;
  optionMappings?: Record<string, {minKey: string; maxKey: string}>;
}

export interface FilterDisplayConfig {
  minKey: string;
  maxKey: string;
  label: string;
  countLabel: string;
  minDigit: number;
  maxDigit: number;
  filterByText: string;
  optionMappings?: Record<
    string,
    {minKey: string; maxKey: string; label: string}
  >;
}

export const FILTER_MAPPINGS: Record<string, FilterMapping> = {
  fqv: {
    minKey: 'fqvMin',
    maxKey: 'fqvMax',
  },
  newCoachesSponsored: {
    minKey: 'newCoachesAbove',
    maxKey: 'newCoachesBelow',
  },
  filterRange: {
    minKey: '', // Will be determined by selected option
    maxKey: '',
    optionMappings: {
      new_clients: {
        minKey: 'newClientsAbove',
        maxKey: 'newClientsBelow',
      },
      q_new_clients: {
        minKey: 'qualifiedClientsAbove',
        maxKey: 'qualifiedClientsBelow',
      },
    },
  },
} as const;

export const FILTER_DISPLAY_CONFIG: Record<string, FilterDisplayConfig> = {
  fqv: {
    minKey: 'fqvMin',
    maxKey: 'fqvMax',
    label: 'Estimated FQV',
    countLabel: 'fqv',
    minDigit: -7,
    maxDigit: 7,
    filterByText: 'Estimated FQV',
  },
  newClients: {
    minKey: 'newClientsAbove',
    maxKey: 'newClientsBelow',
    label: 'New Clients',
    countLabel: 'newClients',
    minDigit: 0,
    maxDigit: 5,
    filterByText: 'New Clients',
  },
  qualifiedClients: {
    minKey: 'qualifiedClientsAbove',
    maxKey: 'qualifiedClientsBelow',
    label: 'Qualified New Clients',
    countLabel: 'qualifiedClients',
    minDigit: 0,
    maxDigit: 5,
    filterByText: 'New Clients',
  },
  newCoachesSponsored: {
    minKey: 'newCoachesAbove',
    maxKey: 'newCoachesBelow',
    label: 'New Coaches (sponsored)',
    countLabel: 'newCoachesSponsored',
    minDigit: 0,
    maxDigit: 5,
    filterByText: 'New Coaches Acquired',
  },
  filterRange: {
    minKey: '', // Will be determined by selected option
    maxKey: '',
    label: 'Filter Range',
    countLabel: 'filterRange',
    minDigit: 0,
    maxDigit: 5,
    filterByText: 'New Clients',
    optionMappings: {
      new_clients: {
        minKey: 'newClientsAbove',
        maxKey: 'newClientsBelow',
        label: 'New Clients',
      },
      q_new_clients: {
        minKey: 'qualifiedClientsAbove',
        maxKey: 'qualifiedClientsBelow',
        label: 'Qualified New Clients',
      },
    },
  },
} as const;
